import api from "~/services/apis/antecipeApi";

// Filtros do backoffice (Leitura+). As telas da empresa usam me.companies (spec §4.5 do login-rbac).
// `active` ausente conta como ativa (spec ux-wave §4.2).
export const getCompanies = async ({ includeInactive = false } = {}) => {
  const response = await api.get(
    "antecipebackoffice/companies",
    includeInactive ? { params: { includeInactive: true } } : undefined
  );
  return response.data.data.map(({ id, name, active }) => ({ id, name, active: active !== false }));
};
